import Ip from './Ip';

export default Ip
export { Ip as Base }